import { render, staticRenderFns } from "./Lgx344012904325971968.vue?vue&type=template&id=1e9354c2&scoped=true&"
import script from "./Lgx344012904325971968.vue?vue&type=script&lang=js&"
export * from "./Lgx344012904325971968.vue?vue&type=script&lang=js&"
import style0 from "./Lgx344012904325971968.vue?vue&type=style&index=0&id=1e9354c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9354c2",
  null
  
)

export default component.exports